import { configureStore } from "@reduxjs/toolkit";

import projectReducer from './projectSlice';
import issueReducer from './IssueSlice';
import trackerReducer from './trackingSlice';
import userReducer from './userSlice';
import documentReducer from './documentSlice';

export const store = configureStore({
    reducer: {
        project: projectReducer,
        issue: issueReducer,
        tracker: trackerReducer,
        user: userReducer,
        document: documentReducer
    }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;